import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import JournalPostForm from '../containers/JournalPostFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class JournalPostAddScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `JournalPostAddScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('journal_post_route_add')} />
          <JournalPostForm />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default JournalPostAddScreen;

Logger.log('silly', `JournalPostAddScreen loaded.`);
